module.exports = __webpack_public_path__ + "static/media/Unimed_Card_Sample.42781acc.png";